<div class="container-fluid container-box pe-0" [ngClass]="{'loaderShow': isDataLoaded}">
  <div  *ngIf="potentialError" [style]="{'height': messageflexHeight}">
    <div class="row">
      <div class=" ipadWrapper">
        <div *ngIf="!importError" class="d-flex justify-content-center  justify-content-md-start">
          <span  class="text-semi-primary no-error">No potential duplicates detected.</span>
      </div>
      <div *ngIf="importError" class="d-flex justify-content-center  justify-content-md-start">
        <span  class="text-semi-primary no-error">No errors detected.</span>
    </div>
    </div>
   </div>
  </div>
<div *ngIf="!potentialError">
  <div class="my-1 mx-3">
    <p class="text-primary-color"> Potential Duplicates</p>
    <span class="font-11 text-gray">
      A record(s) you added looks like a duplicate. Do you want to proceed with adding this record(s)?</span>
  </div>
<ng-container *ngIf="data?.length !== 0">
  <div class="overflow-auto" [style]="{'height': flexHeight}">
    <div class="" *ngFor="let item of data;let i=index">
      <div class="my-2 mx-3 text-semi-primary font-13">
        Duplicate {{i+1}}
      </div>
      <div class="grid-box">
        <app-ag-grid class="center-Pagination d-block position-relative minHeightSet" 
            [ngStyle]="{'height': flexHeight}"
            [dataModel]="dataModel" 
            [paginations]="false" 
            [columnSettings]="false" 
            (gridReady)="onGridReady($event)">
        </app-ag-grid>
        <app-custom-loader *ngIf="!importError" class="position-absolute top-50 start-50 translate-middle" style="z-index: 6;" [isLoaderLoading]="isLoading"></app-custom-loader>
      </div>

      
    </div>
  </div>
</ng-container>
  <div *ngIf="data?.length === 0" [style]="{ height: flexHeight }" class="d-flex justify-content-center align-items-center text-center position-relative top-50">
    No Records Available
  </div>
      </div>
  <div class="row row-gap-2 mt-3 mx-0 position-relative justify-content-center pb-sm-2">
  <div class="d-flex px-0 flex-wrap justify-content-end" [style.width.px]="actWidth">
    <div *ngIf="!potentialError" class="col-12 col-md-4 col-sm-4 error-box">
      <div class="font-11 text-red fw-bold">You have {{data?.length}} potential duplicates.</div>
      <div class="font-11 text-light-gray">Potential duplicates do not get imported unless Import is checked.</div>
    </div>
    <div class="col-12 wrapper mt-5 mt-sm-0 {{importError ? 'col-md-11 d-flex justify-content-center justify-content-sm-end' : 'col-md-8'}}">
      <div class="footer-box">
        <app-button *ngIf="currentTab !== tabName.CODECROSSWALK_TAB"
         class="px-1 px-sm-2" [button_2]="true" [buttonClass]="'button button-info mx-0'"
          [buttonLable]="enumButtonName.CANCEL" (click)="closeTab()">
        </app-button>
        <app-button *ngIf="currentTab === tabName.CODECROSSWALK_TAB"
        class="px-0 px-sm-2" [button_2]="true" [buttonClass]="'button button-info mx-0'"
         [buttonLable]="enumButtonName.CANCEL" (click)="close()">
       </app-button>
        <app-button
        (click)="navigateToErrorTab();isDataLoaded = false"
       class="px-1 px-sm-2"
       [button_2]="true"
       [buttonClass]="'button  dark-info mx-0'"
       [buttonLable]="enumButtonName.PREVIOUS"
      >
        
      </app-button>
        <app-button  class="ps-1 ps-sm-2 " [button_2]="true"
        [buttonClass]="(!potentialError)?'button button-primary mx-0':'button dark-info mx-0'"
         [inputReadonly]="valid"
          [buttonLable]="enumButtonName.COMPLETEIMPORT" (click)="!valid?null:valid = false;moveToEnd()">
        </app-button>
      </div>
    </div>
  </div>
  </div>
</div>
<app-custom-loader class="position-absolute top-50 start-50 translate-middle" style="z-index: 6;" [isLoaderLoading]="isDataLoaded"></app-custom-loader>